import React, { useContext, useEffect, useState } from "react";
import { ReportContext } from "../ReportContext";
import { AuthContext } from "../../auth/AuthContext";
import IssuesTable from "./IssuesTable";
import { motion } from "framer-motion";
import { FaMapMarkedAlt } from "react-icons/fa";

export default function MyIssues() {
  const { issues } = useContext(ReportContext);
  const { currentUser } = useContext(AuthContext);
  const [filteredIssues, setFilteredIssues] = useState([]);

  useEffect(() => {
    if (Array.isArray(issues) && currentUser?.id) {
      const assignedIssues = issues.filter(
        (issue) => issue?.admin_id === currentUser.id
      );
      setFilteredIssues(assignedIssues);
    }
  }, [issues, currentUser]);

  return (
    <motion.div
      className="container my-4 p-4 shadow rounded"
      style={{ border: "1px solid #dee2e6" }}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <motion.div
        className="d-flex align-items-center text-light justify-content-center gap-4 mb-4 position-relative"
        initial={{ opacity: 0, x: -20 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ delay: 0.2 }}
      >
        <h2 className=" fw-bold m-0">My Issues </h2>
        <FaMapMarkedAlt size={28} className="text-success" />
        <button 
        className='btn btn-outline-danger position-absolute end-0 top-0 m-2'
        onClick={()=> window.history.back()}
        >❌</button>
      </motion.div>

      {!!filteredIssues?.length ? (
        <>
          <motion.div
            initial={{ opacity: 0, scale: 0.97 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: 0.3 }}
          >
            <IssuesTable issues={filteredIssues} />
          </motion.div>
        </>
      ) : (
        <motion.div
          className="alert alert-info text-center mt-4"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
        >
          You currently have no issues to Manage.
        </motion.div>
      )}
    </motion.div>
  );
}
